import { render, staticRenderFns } from "./edit-wen.vue?vue&type=template&id=078a3fb3&scoped=true"
import script from "./edit-wen.vue?vue&type=script&lang=ts"
export * from "./edit-wen.vue?vue&type=script&lang=ts"
import style0 from "./edit-wen.vue?vue&type=style&index=0&id=078a3fb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078a3fb3",
  null
  
)

export default component.exports